<template>
    <div
        class="address-input gf"
        :class="showUnitField ? 'show-unit-input' : ''"
    >
        <div
            class="address-header"
            v-if="addressHeaderContent"
            v-html="formatFontSize(addressHeaderContent, 28)"
        ></div>
        <div v-show="errorShow" class="empty-errors">
            {{ $t('common:validAddressRequired') }}
        </div>
        <div class="address-body">
            <div class="left-box">
                <input
                    :style="addressInputStyle"
                    ref="input"
                    type="text"
                    autocomplete="off"
                    class="input"
                    :class="{ error: errorShow }"
                    :placeholder="cmpPlaceholder"
                    v-model="address"
                    @focus="onFocus"
                    @input="onInput"
                    @compositionstart="onCompositionstart"
                    @compositionend="onCompositionend"
                    @blur="onBlur"
                    @keydown="onKeyDown"
                />
                <div
                    class="close-box"
                    :class="{ show: !!address }"
                    @click="clearAddress"
                >
                    <span class="iconfont icon-search-close"></span>
                </div>
            </div>
            <div class="right-box">
                <input
                    v-if="showUnitField"
                    type="text"
                    autocomplete="off"
                    class="unit-input"
                    :placeholder="$t('common:placeholder.unit')"
                    maxlength="20"
                    v-model="unit"
                    :style="addressInputStyle"
                    @focus="onUnitFocus"
                    @blur="onBlur"
                    @keydown="onKeyDown"
                />
                <span
                    class="iconfont icon-search icon-submit-btn"
                    @click="onSubmit"
                    v-show="submitBtnStyle === 'icon'"
                ></span>

                <span
                    :style="submitStyle"
                    class="submit-btn"
                    @click="onSubmit"
                >{{ submitText }}</span
                >
            </div>
        </div>
    </div>
</template>

<script>
import common from './common';
export default {
    mixins: [common],
    props: {
        addressHeaderStyle: {
            type: Object
        },
        addressHeaderContent: {
            type: String,
            default: 'Enter your address below'
        },
        submitStyle: {
            type: Object
        },
        addressInputStyle: {
            type: Object
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
@mixin center-block {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.address-input.gf {
    max-width: 100%;
    margin: 0 auto;
    .address-header {
        color: #fff;
        font-size: 28px;
        font-family: var(--font-bold);
        text-align: center;
        text-shadow: 1px 2px 0 #333;
    }
    .empty-errors {
        font-size: 22px;
        color: #600;
        margin: 0 auto;
        width: 77%;
        background-color: white;
        border-radius: 4px;
        text-align: center;
        box-shadow: 2px 2px 2px #7f7f7e;
        padding: 15px;
        font-size: 22px;
        margin-bottom: 15px;
    }
    .address-body {
        position: relative;
        display: flex;
        width: 100%;
        height: 50px;
        margin-top: 20px;
        .left-box {
            flex: 1;
            position: relative;
            margin-right: 30px;
        }
        .right-box {
            flex: none;
            position: relative;
        }
        .input {
            padding-left: 20px;
            padding-right: 34px;
            width: 100%;
            height: 50px;
            padding-top: 10px;
            padding-bottom: 10px;
            line-height: 30px;
            font-size: 18px;
            color: var(--color-label);
            border: none;
            box-shadow: none;
            margin: 0;
            border-radius: 4px;
            border: 1px solid transparent;
            &.error {
                background-color: #ffb3b3;
            }
            &:focus {
                outline: none;
                @include color-theme('border', 1px solid);
                box-shadow: 0 0 10px #7f7f7e;
            }
        }
        .unit-input {
            width: 165px;
            height: 50px;
            font-size: 18px;
            color: var(--color-label);
            box-sizing: border-box;
            border: none;
            box-shadow: none;
            margin-right: 30px;
            padding: 10px 14px;
            line-height: 30px;
            border-radius: 4px;
            border: 1px solid transparent;
            &:focus {
                outline: none;
                @include color-theme('border', 1px solid);
                box-shadow: 0 0 10px #7f7f7e;
            }
        }
        .close-box {
            display: none;
            position: absolute;
            top: 18px;
            right: 20px;
            height: 14px;
            width: 14px;
            cursor: pointer;
            &.show {
                display: block;
            }
            .icon-search-close {
                @include center-block;
                border-radius: 50%;
                width: 14px;
                height: 14px;
                &:before {
                    @include center-block;
                    font-size: 14px;
                    color: var(--color-holder);
                    background-color: #fff;
                }
            }
        }
        .submit-btn {
            display: inline-block;
            vertical-align: top;
            min-width: 165px;
            max-width: 300px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            padding: 0 20px;
            margin: 0;
            flex: none;
            @include color-theme('background-color');
            font-family: var(--mg-button-font);
            color: #fff;
            font-size: 18px;
            border: 1px solid transparent;
            border-radius: 4px;
            @include color-theme('box-shadow', 4px 4px 5px inset);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            &:hover {
                border-color: #adadad;
            }
        }
        .icon-submit-btn {
            display: none;
            @include media-800 {
                display: block;
            }
        }
        ::-webkit-input-placeholder {
            color: var(--color-holder);
            font-size: 18px;
        }

        ::-moz-placeholder {
            color: var(--color-holder);
            font-size: 18px;
        }

        ::-ms-input-placeholder {
            color: var(--color-holder);
            font-size: 18px;
        }
    }
    @include media-840 {
        max-width: 92%;
        .address-header {
            padding: 20px 0;
        }
        .address-body {
            height: auto;
            display: flex;
            flex-direction: column;
            .left-box {
                flex: 1;
                position: relative;
                margin-bottom: 15px;
                margin-right: 0;
            }
            .right-box {
                width: 100%;
                flex: 1;
                .icon-search {
                    margin-right: 8px;
                    cursor: pointer;
                    color: #7f7f7e;
                }
            }
            .input {
                width: 100%;
                padding-left: 10px;
                padding-right: 10px;
                height: 50px;
            }
            .unit-input {
                width: 100%;
                margin-bottom: 15px;
                margin-right: 0;
            }
            .submit-btn {
                width: 100%;
                max-width: initial;
            }
            .close-box.show {
                display: none;
            }
        }
        .empty-errors {
            top: 50px;
            width: 100%;
            font-size: 16px;
        }
    }
}
</style>
